import { indexBy, prop } from 'ramda'

export enum EStatusPill {
  Available = 'Available',
  Preparing = 'Preparing',
  Charging = 'Charging',
  SuspendedEVSE = 'SuspendedEVSE',
  SuspendedEV = 'SuspendedEV',
  Finishing = 'Finishing',
  Reserved = 'Reserved',
  Unavailable = 'Unavailable',
  Faulted = 'Faulted',
  Repairing = 'repairing',
  Occupy = 'Occupy',
}

export const ChargingPointDetailStatusColor: Record<string, string> = {
  [EStatusPill.Available]: 'rgba(32, 228, 255, 0.5)',
  [EStatusPill.Preparing]: '#2196F3',
  [EStatusPill.Charging]: 'rgba(255, 129, 47, 0.5)',
  [EStatusPill.SuspendedEVSE]: '#FF5722',
  [EStatusPill.SuspendedEV]: '#FF5722',
  [EStatusPill.Finishing]: '#9C27B0',
  [EStatusPill.Reserved]: '#03A9F4',
  [EStatusPill.Unavailable]: 'rgba(255, 255, 255, 0.1)',
  [EStatusPill.Faulted]: '#FF000080',
  [EStatusPill.Repairing]: '#FF5722',
  [EStatusPill.Occupy]: '#9C27B0',
}

export const useChargeStatusEnum = () => {
  const statusEnum = Object.fromEntries(
    Object.entries(EStatusPill).map(([key, value]) => [key, value])
  )

  const data = [
    {
      id: 'Available',
      label: '可使用',
    },
    {
      id: 'Preparing',
      label: '準備充電',
    },
    {
      id: 'Charging',
      label: '充電中',
    },
    {
      id: 'SuspendedEVSE',
      label: '充電樁停止充電',
    },
    {
      id: 'SuspendedEV',
      label: '車輛停止充電',
    },
    {
      id: 'Reserved',
      label: '預定',
    },
    {
      id: 'Unavailable',
      label: '無服務',
    },
    {
      id: 'Faulted',
      label: '故障',
    },
    {
      id: EStatusPill.Finishing,
      label: '充電完成',
    },
    {
      id: EStatusPill.Occupy,
      label: '占用中',
    },
  ]

  const byId = indexBy(prop('id'), data)

  return {
    data,
    byId,
    statusEnum,
  }
}

export const useParkingSpaceEnum = () => {
  const data = [
    {
      key: 'PRIORITY',
      label: '優先車格',
    },
    {
      key: 'DEDICATED',
      label: '專用車格',
    },
  ]

  const byKey = indexBy(prop('key'), data)

  return {
    data,
    byKey,
  }
}
